<template>
  <zen-one :showuserinfo="false" :crumbs="crumbs" title="">
    <z-page title="Perolehan LN2" >
      <w-card bg-color="" class="">
        <div class="w-flex wrap smd-column" >
          <div class="mx2"></div>
          <div class="grow ">
            <div class="w-flex wrap smd-column" >
              <div class="grow ">
                <table >
                  <tbody>
                  <tr class="row_data">
                     <td><b>Tarikh Perolehan</b></td>
                     <td><b>:</b></td>
                     <td>{{ $zutil.dateformat(data.tarikh)}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Isipadu (m3)</b></td>
                     <td><b>:</b></td>
                     <td>{{data.isipadu}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Harga (RM)</b></td>
                     <td><b>:</b></td>
                     <td>{{data.harga}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Nama Pembekal</b></td>
                     <td><b>:</b></td>
                     <td>{{data.name}}</td>
                  </tr>
                  <tr class="row_data">
                     <td><b>Sumber Peruntukan</b></td>
                     <td><b>:</b></td>
                     <td>{{data.lkp_sumber_peruntukan}}</td>
                  </tr>
                  </tbody>
                  </table>
              </div>
              
            </div>
          </div>
        </div>
        
      </w-card>
      <div class="mt2 text-left">
        <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
      </div>
    </z-page>
  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { VueperSlides, VueperSlide } from 'vueperslides'
import 'vueperslides/dist/vueperslides.css'
// import Pengambilan from './Show/Pengambilan.vue';

export default {
  extends: ZResource,
  components: {
    VueperSlides, VueperSlide
  },
  props: {
    id: [Array, Object, String],
  },
  data() {
    return {
      resourceurl: 'tangki.perolehan',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Tangki LN2', route: '/tangki' },
        { label: 'Perolehan LN2', route: '/tangki/perolehan' },
        { label: 'Papar', route: '/tangki/perolehan/'+this.id },
      ],
      data : {id : 0},
      
      tabs: [
      		  { title: 'Tangki Perolehan', content: '' },
          ]
    }
  },
  methods: {

    getData()
    {
      this.$zcomm.get(this.api_service + 'tangki_perolehan/show/'+this.id, {}).then(res => {
        this.data = res
        
        // this.listTabs()
      })

    },

   
   tutup(){
         this.$inertia.visit(window.route('tangki.perolehan.index'));
       },
   
   

   

  },
  watch: {

  },
  mounted() {
    this.getData();
  },
}
</script>
